import PageRouter from './PageRouter';
import RefCapture from './components/RefCapture';

function App() {
  return (
    <>
      <RefCapture />
      <PageRouter />
    </>
  );
}

export default App;
